import React from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    Grid,
    TextField,
    Typography,
} from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Button from '../../../controls/Button';
import ResultMappingSection from '../RepeatableFieldSearch/ResultMappingSection';

const headerSizing = 'small';

const styles = (theme) => ({
    dialogPaper: {
        minHeight: '80vh',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
    },
    searchPropertiesTitle: {
        marginTop: theme.spacing(5),
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    section: {
        marginTop: theme.spacing(3),
        background: '#F8F8F8',
        padding: theme.spacing(3),
    },
    whiteBackground: {
        backgroundColor: 'white',
    },
    dialogPadding: {
        paddingLeft: theme.spacing(7),
        paddingRight: theme.spacing(7),
    },
    actionButtons: {
        padding: theme.spacing(3),
    },
    grey: {
        color: '#484848',
    },
    searchProperties: {
        fontSize: 20,
        color: '#484848',
        fontWeight: 'bold',
    },
    enterOwner: {
        color: '#6E7788',
    },
    autoComplete: {
        marginTop: theme.spacing(3),
        backgroundColor: 'white',
    },
    typography: { paddingBottom: theme.spacing(2) },
});
class SearchPropertiesDialog extends React.Component {
    state = {
        field: this.props.field,
        allowCustomValue: !!this.props.searchForm.addRecordText,
        addRecordText: this.props.searchForm.addRecordText,
        url: this.props.searchForm.url,
        resultMappings: this.props.searchForm.resultMappings ?? [],
    };

    handleClose = () => {
        this.props.handleCancelSearchPropertiesDialog();
    };

    handleAllowCustomValue = (event) => {
        this.setState({
            allowCustomValue: !this.state.allowCustomValue,
        });
        if (event.target.checked === false) {
            this.setState({
                addRecordText: '',
            });
        }
    };

    handleChangeUrl = (value) => {
        this.setState({
            url: value,
        });
    };

    handleChange = (event) => {
        const tag = event.target.id || event.target.name;
        const value = event.target.value;
        this.setState(() => ({
            [tag]: value,
        }));
    };

    handleDone = () => {
        const scrubbedResultMappings = this.state.resultMappings.filter(function (resultMapping) {
            return resultMapping.title !== '' || resultMapping.field !== '' || resultMapping.mapping !== '';
        });
        this.props.handleDoneSearchPropertiesDialog(this.state.addRecordText, this.state.url, scrubbedResultMappings);
    };

    render() {
        const searchEndpoints = [
            { label: 'Person Search', value: '/persons' },
            { label: 'License Search', value: '/licenses' },
        ];
        return (
            <React.Fragment>
                <Dialog
                    disableBackdropClick
                    fullWidth
                    maxWidth={'md'}
                    open={this.props.open}
                    onClose={this.handleClose}
                    classes={{ paperScrollPaper: this.props.classes.dialogPaper }}
                    PaperProps={{ 'aria-label': this.props.field.field }}
                >
                    <DialogTitle
                        disableTypography={true}
                        className={this.props.classes.searchPropertiesTitle}
                        classes={{ root: this.props.classes.dialogPadding }}
                    >
                        <Typography className={this.props.classes.searchProperties}>Search Properties</Typography>
                        <Typography className={this.props.classes.enterOwner}>
                            Field: {this.props.field.field}
                        </Typography>
                    </DialogTitle>

                    <DialogContent classes={{ root: this.props.classes.dialogPadding }} role={'main'}>
                        <form noValidate className={this.props.classes.form}>
                            <FormControl>
                                <Grid container className={this.props.classes.section}>
                                    <Grid item xs={12} className={this.props.classes.typography}>
                                        <Typography variant="h6">
                                            This will allow the user to search for values.
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            label={
                                                <Typography className={this.props.classes.grey}>
                                                    User can enter a custom value if searching does not provide results
                                                </Typography>
                                            }
                                            control={
                                                <Checkbox
                                                    id={'allowCustomValue'}
                                                    name={'allowCustomValue'}
                                                    checked={this.state.allowCustomValue}
                                                    key={'allowCustomValue'}
                                                    color={'primary'}
                                                    onChange={(e) => this.handleAllowCustomValue(e)}
                                                />
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        {this.state.allowCustomValue && (
                                            <TextField
                                                id="addRecordText"
                                                label="Add Record Text"
                                                fullWidth
                                                rows={1}
                                                value={this.state.addRecordText}
                                                className={this.props.classes.whiteBackground}
                                                margin="normal"
                                                variant="outlined"
                                                onChange={(e) => this.handleChange(e)}
                                            />
                                        )}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Autocomplete
                                            id="url"
                                            fullWidth
                                            value={this.state.url}
                                            className={this.props.classes.autoComplete}
                                            options={searchEndpoints}
                                            getOptionLabel={(option) => {
                                                if (typeof option === 'string') {
                                                    const selectedOption = searchEndpoints.find(
                                                        (searchEndpoint) => searchEndpoint.value === option,
                                                    );
                                                    return selectedOption.label;
                                                }

                                                return option.label;
                                            }}
                                            onChange={(event, newValue, reason) => {
                                                if (reason === 'clear') {
                                                    this.handleChangeUrl(null);
                                                } else {
                                                    this.handleChangeUrl(newValue.value);
                                                }
                                            }}
                                            renderOption={(option) => option.label}
                                            renderInput={(params) => (
                                                <TextField {...params} label="Endpoint URL" variant="outlined" />
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                                <ResultMappingSection
                                    field={this.props.field}
                                    handleChange={this.handleChange}
                                    resultMappings={this.state.resultMappings}
                                    multipleSubFields={this.props.multipleSubFields}
                                />
                            </FormControl>
                        </form>
                    </DialogContent>
                    <DialogActions classes={{ root: this.props.classes.actionButtons }}>
                        <Button size={headerSizing} onClick={this.props.handleCancelSearchPropertiesDialog}>
                            Cancel
                        </Button>
                        <Button size={headerSizing} variant="contained" color="primary" onClick={this.handleDone}>
                            Done
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(SearchPropertiesDialog);
